const openUpdateGroupDialog = id => ({
  type: 'GROUPS:UPDATE_GROUP_DIALOG:OPEN',
  id
})

const closeUpdateGroupDialog = () => ({
  type: 'GROUPS:UPDATE_GROUP_DIALOG:CLOSE'
})

export { openUpdateGroupDialog, closeUpdateGroupDialog }
